import { BaseExternalsEndpoints } from './base';

export interface External {
  id: string;
  external_id: string;
  name: string;
  object_id: string;
  object_type: string;
  organization_id: string;
  created: string;
  updated: string;
  deleted: string;
  created_by_user_id: string;
  updated_by_user_id: string;
  deleted_by_user_id: string;
}


export class Externals extends BaseExternalsEndpoints {
  async getExternalIds(object_id: string, object_type?: string, type?: string) {
    const params = new URLSearchParams({object_id});
    if (object_type) {
      params.set('object_type', object_type);
    }
    if (type) {
      params.set('type', type);
    }
    const result = await this.requestWithStatus<External[]>(
      'GET',
      `/v1/externals?${params.toString()}`,
    );
    return result;
  }

  async deleteExternalId(id: string) {
    const result = await this.requestWithStatus<External>(
      'DELETE',
      `/v1/externals/${id}`,
    );
    return result;
  }

  async createExternalId(data: Partial<External>) {
    const result = await this.requestWithStatus<External[]>(
      'POST',
      '/v1/externals',
      data,
    );
    return result;
  }
}
